import $ from "jquery";
import jQuery from "jquery";
import Swiper from "./swiper";

// export for others scripts to use
window.$ = $;
window.jQuery = jQuery;

// // set CSRF token for every AJAX request using jquery.cookie
require('jquery.cookie');
require('jquery.mmenu/dist/jquery.mmenu.all.css');
require('jquery.mmenu/dist/jquery.mmenu.all');
$.ajaxSetup({headers: {'X-XSRF-TOKEN': $.cookie('XSRF-TOKEN')}});

//

function setheader_image() {
}

$(function () {

    setheader_image();
    $(window).on('resize', setheader_image());

    let $time = 1000;
    let div = $('.detail_right_side');

    if (div.length) {
        let blocks = $('.detail_right_side_blocks');
        let $height = $('.page_header').height() / 2;

        let divForm = div.find('.form');
        div.animate({top: -$height}, $time);
        divForm.animate({opacity: 1}, $time);

        setTimeout(function () {
            blocks.animate({opacity: 1}, $time / 2);
        }, $time);

        let closestContainer = div.closest('.container');

        $(window).on('load resize', function () {

            let closestContainerHeight = closestContainer.height();
            let divHeight = div.height();
            let divRelativeHeight = (divHeight - $height) + 50;

            if ($(window).width() < 1200) {
                closestContainer.css('height', 'auto');
                return false;
            }

            if (divRelativeHeight >= closestContainerHeight) {
                closestContainer.css('height', divRelativeHeight);
            } else {
                closestContainer.css('height', 'auto');
            }
        });
    }


    $('.swiper-container-holder').each(function () {
        let $this = $(this);
        let swiper = new Swiper($this.find('.swiper-container'), {
            spaceBetween: 30,
            loop: true,
            navigation: {
                nextEl: $this.find('.swiper-button-next'),
                prevEl: $this.find('.swiper-button-prev'),
            },
            slidesPerView: 2,
            breakpoints: {
                // when window width is <= 320px
                768: {
                    slidesPerView: 1,
                }
            }
        });

    });

});

$(function () {

    $('ul.tabs li').click(function () {
        var tab_id = $(this).attr('data-tab');
        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#tab-" + tab_id).addClass('current');
    })

    var $hamburger = $(".hamburger");
    $hamburger.on("click", function (e) {
        $hamburger.toggleClass("is-active");
        // Do something else, like open/close menu
    });


    let $mmenu = $("#menu").mmenu({
        "extensions": [
            "position-right",
            "pagedim-black"
        ]
    });

    var $mmenuButton = $('#mmenu-button');

    var mmenuAPI = $mmenu.data("mmenu");

    mmenuAPI.bind("open:finish", function () {
        $mmenuButton.addClass("is-active");
    });

    mmenuAPI.bind("close:start", function () {
        $mmenuButton.removeClass("is-active");
    });


    $('form').each(function () {
        let $form = $(this);

        $form.on('submit', function () {
            let $text = $form.find('button').text();
            $form.find('button').html('<i class="fa fa-spin fa-spinner"></i>');
            $form.find('.is-invalid').removeClass('is-invalid');

            $.post($form.attr('action'), $form.serializeArray(), function (response) {
                if (response.success) {
                    if ($form.data('ga') && window.gtag !== undefined) {
                        gtag('event', 'macro-conversie', {
                            'event_category': $form.data('ga'),
                            'event_label': $form.data('url')
                        });
                    }

                    if (response.redirect) {
                        window.location.href = response.redirect;
                    } else {
                        $form.find('button').html('Verstuurd');
                        $form.find('input').val("");
                        $form.find('textarea').val("");

                        setTimeout(function () {
                            $form.find('button').html($text);
                        }, 3000)
                    }
                }
            }).fail(function (r) {
                $form.find('button').html($text);
                for (let i in r.responseJSON) {
                    $form.find('[name=' + i + ']').addClass('is-invalid');
                }

            });
            return false;
        });
    });


    $('.faq-items').each(function () {
        $(this).on('click', function () {
            let $this = $(this);
            $this.find('.faq-answere').slideToggle();
        })
    })


    let latlng = $('#map').data('gps');
    if (latlng) {
        var map = new google.maps.Map(document.getElementById('map'), {
            // scrollwheel: false,
            disableDefaultUI: true,

        });
        var bounds = new google.maps.LatLngBounds();

        for (let $i = 0; $i < latlng.length; $i++) {
            var marker = new google.maps.Marker({
                position: {
                    lat: +latlng[$i][0],
                    lng: +latlng[$i][1]
                },
                map: map,
            });
            bounds.extend(marker.position);
        }
        map.fitBounds(bounds);
        setTimeout(function () {
            let zoomData = $('#map').data('zoom');
            var zoom;

            if (zoomData !== undefined) {
                zoom = zoomData;
            } else {
                zoom = map.getZoom();
            }

            map.setZoom(zoom);
        }, 200)

    }

});

$(document).ready(function () {
    setTimeout(function () {
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
        head.appendChild(script);
    }, 3000);

    var onloadCallback = function () {
        $(".g-recaptcha").each(function () {
            var object = $(this);

            try {
                grecaptcha.render(object.attr("id"), {
                    "sitekey": window.sitedata.recaptchakey,
                    "callback": function (token) {
                        object.parents('form').find(".g-recaptcha-response").val(token);
                        object.parents('form').submit();
                    }
                });
            } catch (error) {
            }
        });
    };

    window.onloadCallback = onloadCallback;
});

